export const combineMultipleReducers = (...reducerDics) => {
    const output = {};
    reducerDics
        .forEach(reducerDic => {
        Object.keys(reducerDic)
            .forEach(action => {
            if (!output[action]) {
                output[action] = reducerDic[action];
                return;
            }
            const originalReducer = output[action];
            output[action] = (params) => {
                const stateA = params.state || {};
                const stateB = originalReducer(Object.assign(Object.assign({}, params), { state: stateA }));
                return reducerDic[action](Object.assign(Object.assign({}, params), { state: Object.assign(Object.assign({}, stateA), stateB) }));
            };
        });
    });
    return output;
};
